import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import AppBar from 'src/components/UI/appbar/AppBar';
import CustomDrawer from '../appbar/CustomDrawer';
import { useLocation } from 'react-router-dom';
import { AnnouncementsProvider } from 'src/store/AnnouncementsContext';

const offset = 65;

const Root = styled('div')({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden'
});

const Main = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  overflowY: 'hidden',
  flex: 1,
  height: '100vh'
}));

const Content = styled('main')(({ theme }) => ({
  position: 'relative',
  flex: 1,
  padding: theme.spacing(1),
  paddingTop: theme.spacing(4),
  overflowY: 'auto',
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6)
  },
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  marginTop: offset
}));

const ContentShift = styled(Content)(({ theme }) => ({
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen
  })
}));

export default function MainContainer(props) {
  const location = useLocation();
  const query = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const isEmbeddedChart = query.get('embed') === 'chart';
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);

  return (
    <AnnouncementsProvider>
      <Root>
        <AppBar
          menuItems={props.menuItems}
          minimal={isEmbeddedChart}
          mobileNavOpen={mobileNavOpen}
          onToggleMobileNav={() => setMobileNavOpen((prev) => !prev)}
        />
        <Main>
          {!isEmbeddedChart && (
            <CustomDrawer
              navItems={props.navItems}
              mobileNavOpen={mobileNavOpen}
              onMobileNavClose={() => setMobileNavOpen(false)}
            />
          )}
          <Content
            className={clsx({
              [ContentShift]: open,
              [props.className]: props.className
            })}
          >
            {props.children}
          </Content>
        </Main>
      </Root>
    </AnnouncementsProvider>
  );
}
